import * as React from 'react';
import { SVGProps } from 'react';

const IconTopRightSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.859 3.952 3.702 9.109l-.707-.707 5.157-5.157H4.409v-1h5.45v5.45h-1V3.952Z" />
  </svg>
);
export default IconTopRightSizeXs;
